<template>
	<div id="app">
		<keep-alive :include="[cachedComponents, 'xuanzMb', 'tihuanKt', 'banjiHome', 'kejianTj']">
			<router-view></router-view>
		</keep-alive>
	</div>
</template>

<script>
import { mapState } from 'vuex';
export default {
	name: 'App',
	computed: {
		...mapState(['cachedComponents'])
	},
	mounted() {
		// 小程序二维码
		this.$http.get(`api/system/dict/data/config/app_mini_pic`).then((res) => {
			if (res.code == 200) {
				localStorage.setItem('appMiniPic', JSON.stringify(res.data));
				this.$store.commit('setAppMiniPic', res.data);
			}
		});
		// 公众号二维码
		this.$http.get(`api/system/dict/data/config/app_weixin_official_accounts_pic`).then((res) => {
			if (res.code == 200) {
				localStorage.setItem('appWxOffic', JSON.stringify(res.data));
				this.$store.commit('setAppWxOffic', res.data);
			}
		});
		// 公司logo
		this.$http.get(`api/system/dict/data/config/app_logo`).then((res) => {
			if (res.code == 200) {
				localStorage.setItem('appLogo', JSON.stringify(res.data));
				this.$store.commit('setAppLogo', res.data);
			}
		});
		// 客服电话
		this.$http.get(`api/system/dict/data/config/app_service_phone`).then((res) => {
			if (res.code == 200) {
				localStorage.setItem('appPhone', JSON.stringify(res.data));
				this.$store.commit('setAppPhone', res.data);
			}
		});
		// 工作时间
		this.$http.get(`api/system/dict/data/config/app_service_time`).then((res) => {
			if (res.code == 200) {
				localStorage.setItem('appTime', JSON.stringify(res.data));
				this.$store.commit('setAppTime', res.data);
			}
		});
		// 公司名称
		this.$http.get(`api/system/dict/data/config/app_company`).then((res) => {
			if (res.code == 200) {
				localStorage.setItem('appCompany', JSON.stringify(res.data));
				this.$store.commit('setAppCompany', res.data);
			}
		});
		this.$http.get(`api/system/dict/data/config/app_icp`).then((res) => {
			if (res.code == 200) {
				localStorage.setItem('icpData', JSON.stringify(res.data));
				this.$store.commit('setIcpData', res.data);
			}
		});
		this.$http.get(`api/system/dict/data/config/app_gongan`).then((res) => {
			if (res.code == 200) {
				localStorage.setItem('gaData', JSON.stringify(res.data));
				this.$store.commit('setGaData', res.data);
			}
		});
		this.$http
			.get('api/app/yydBanner/list', {
				params: {
					type: 6
				}
			})
			.then((res) => {
				if (res.code == 200) {
					localStorage.setItem('wjData', JSON.stringify(res.data));
				}
			});
		this.$http
			.get('api/app/yydBanner/list', {
				params: {
					type: 7
				}
			})
			.then((res) => {
				if (res.code == 200) {
					localStorage.setItem('mtData', JSON.stringify(res.data));
				}
			});
	}
};
</script>

<style lang="scss">
.el-popup-parent--hidden {
	padding-right: 0 !important;
}
@import './assets/css/reset.css';
@import './assets/css/common.scss';

.bodyWrapper {
	width: 1200px;
	position: relative;
	margin: 0 auto;
}
.gudBtns {
	position: absolute;
	top: 0;
	left: -65px;
	width: 58px;
	.gudBtnItem {
		width: 58px;
		height: 58px;
		margin-bottom: 4px;
		background: #fff;
		border-radius: 4px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		color: #8f9190;
		font-size: 12px;
		position: relative;
		cursor: pointer;
		&.gudBack {
			img {
				width: 22px;
				height: 22px;
			}
		}
		img {
			margin-bottom: 3px;
		}
	}
}

.supHove1 {
	transition: all 0.3s;
	&:hover {
		// transform: scale(1.1);
		position: relative;
		margin-top: -5px;
		z-index: 999;
		box-shadow: 0px 3px 15px 0px rgba(0, 0, 0, 0.2) !important;
	}
}
.el-carousel__indicators--horizontal {
	bottom: 37px;
	.el-carousel__button {
		width: 12px;
		height: 12px;
		border-radius: 50%;
	}
}
h2 {
	font-weight: normal;
	font-size: 14px;
}
.supHove2 {
	transition: all 0.3s;
	&:hover {
		position: relative;
		transform: scale(1.1);
		z-index: 9999;
	}
}

.supHove3 {
	&:hover {
		opacity: 0.75;
	}
}
.supHove4 {
	overflow: hidden;
	&:hover {
		img {
			transition: all 0.5s;
			transform: scale(1.1);
		}
	}
}
.supHove5 {
	overflow: hidden;
	&:hover {
		> div > div > img {
			transition: all 0.5s;
			transform: scale(1.1);
		}
	}
}

.meiWecFjFot1 {
	.meiWecFjItem {
		&:nth-of-type(1) {
			img {
				filter: grayscale(0%) !important;
			}
		}
	}
}
.meiWecFjFot2 {
	.meiWecFjItem {
		&:nth-of-type(2) {
			img {
				filter: grayscale(0%) !important;
			}
		}
	}
}
.meiWecFjFot3 {
	.meiWecFjItem {
		&:nth-of-type(3) {
			img {
				filter: grayscale(0%) !important;
			}
		}
	}
}
.el-cascader-node.is-selectable.in-checked-path {
	color: #1d7b3a !important;
}
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
	border-color: #1d7b3a !important;
	background-color: #1d7b3a !important;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
	color: #1d7b3a !important;
}
.el-checkbox__inner:hover {
	border-color: #1d7b3a !important;
}
.el-checkbox__input.is-focus .el-checkbox__inner,
.el-checkbox__input.is-checked + .el-checkbox__label,
.el-cascader .el-input .el-input__inner:focus,
.el-cascader .el-input.is-focus .el-input__inner {
	border-color: #1d7b3a !important;
}
.el-checkbox .el-checkbox__label {
	font-size: 12px; /* 设置字体大小为16px */
}
@font-face {
	font-family: 'fsFont';
	/* src引入需要精简的ttf字体文件 */
	src: url('@/assets/font/hanyihuangkezhuanglif.ttf');
	font-weight: normal;
	font-style: normal;
}
/* //有子节点 且未展开 */
.el-tree .el-icon-caret-right:before {
	background: url('@/assets/img/jia.svg') no-repeat 5px 4px;
	content: '';
	display: block;
	width: 20px;
	height: 20px;
	font-size: 16px;
	background-size: 13px;
}
.el-tree-node__expand-icon.is-leaf {
	width: 32px;
	height: 32px;
	box-sizing: border-box;
}
.el-tree-node__expand-icon {
	position: relative;
}
/* //有子节点 且已展开 */
.el-tree .el-tree-node__expand-icon.expanded.el-icon-caret-right:before {
	background: url('@/assets/img/jian.svg') no-repeat 3px 2px;
	content: '';
	display: block;
	width: 20px;
	height: 20px;
	font-size: 16px;
	background-size: 17px;
}
/* //没有子节点 */
.el-tree .el-tree-node__expand-icon.is-leaf::before {
	background: #fff;
	content: '';
	display: block;
	width: 0px;
	height: 0px;
	font-size: 16px;
	background-size: 16px;
}
//高亮字体颜色
.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
	color: #409eff !important;
}
.el-tree .el-tree-node__expand-icon.expanded {
	-webkit-transform: rotate(0deg);
	transform: rotate(0deg);
}

.el-tree .el-tree-node__expand-icon.expanded {
	-webkit-transform: rotate(0deg);
	transform: rotate(0deg);
}
.shepherd-element {
	background: #1d7b3a !important;
	border: none !important;
	.shepherd-arrow {
		&::before {
			background: #1d7b3a !important;
		}
	}
	.shepherd-button {
		background: #ffffff;
		border-radius: 4px;
		color: #1d7b3a;
		&:hover {
			background: #ffffff !important;
			color: #1d7b3a !important;
		}
	}
	.tcTit {
		color: #fff;
		font-size: 16px;
		font-weight: bold;
		margin-bottom: 9px;
	}
	.tcP {
		font-size: 14px;
		color: #fff;
	}
}
.btnS {
	border-style: none;
}

/* 覆盖Element UI表单验证错误信息的样式 */
.el-form .el-form-item.is-error .el-input__inner,
.el-form .el-form-item.is-error .el-select__input {
	color: #dd6969; /* 使用!important确保覆盖 */
	background: #fff0f1;
}
.upBoxs {
	.el-form-item__error {
		margin-top: 52px;
	}
}
.el-dialog {
	border-radius: 8px;
}

.el-button:focus,
.el-button:hover {
	background-color: #fff;
	color: #2fa856;
	border-color: #2fa856;
}
.el-button--primary {
	background-color: #1d7b3a !important;
	color: #fff !important;
	border-color: #1d7b3a;
	&:hover {
		background-color: #2fa856 !important;
		border-color: #2fa856 !important;
	}
}
.delBtns {
	background-color: #d33931 !important;
	color: #fff;
	border-color: #d33931 !important;
	&:hover {
		background-color: #d33931 !important;
		border-color: #d33931 !important;
	}
}
.el-input__inner:focus,
.el-textarea__inner:focus,
.el-upload:focus,
.el-upload:hover,
.el-range-editor.is-active,
.el-range-editor.is-active:hover,
.el-select .el-input.is-focus .el-input__inner,
.el-select .el-input__inner:focus,
.el-pagination__sizes .el-input .el-input__inner:hover {
	outline: none;
	border-color: #1d7b3a;
}
.el-upload:focus,
.el-pager li:hover,
.el-select-dropdown__item.selected,
.el-dialog__headerbtn:hover .el-dialog__close,
.el-radio__input.is-checked + .el-radio__label {
	color: #1d7b3a;
}
.el-pager li.active {
	color: #000000;
}
.el-pager li {
	color: #fff;
}
.el-pager .number {
	color: #acacac;
}
.el-loading-spinner i,
.el-loading-spinner .el-loading-text {
	color: #fff;
}
.el-radio__input.is-checked .el-radio__inner {
	border-color: #1d7b3a;
	background: #1d7b3a;
}
.el-image__inner {
	width: 100%;
	height: 100%;
	border-radius: 6px;
	object-fit: cover;
}
.el-image {
	width: 100%;
	height: 100%;
	border-radius: 8px;
}
.el-loading-mask {
	background: transparent;
}
.el-loading-spinner .path {
	stroke: #1d7b3a;
}
.kaoshiWtBtn2 {
	background: #d80073 !important;
	position: relative;
	width: 70px;
}
.kaoshiWtBtn1 {
	background: #d80073 !important;
	position: relative;
	width: 70px;
	&:hover {
		.kaoshiBox {
			display: block;
		}
	}
	.kaoshiBox {
		position: absolute;
		top: 26px;
		left: 0;
		width: 100%;
		color: #000000;
		background: #fff;
		display: none;
		.ksItem {
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 12px;
			height: 26px;
			&:hover {
				color: #1d7b3a;
			}
			i {
				margin-top: 2px;
				margin-right: 4px;
			}
		}
	}
}
html {
	overflow-y: scroll; /* 强制始终显示垂直滚动条（无内容时显示灰色不可滚动条） */
	font-family: Arial, Helvetica, sans-serif;
}
// *{
// ::-webkit-scrollbar {
//     /*隐藏滚轮*/
//     display: none;
//     }
// }
</style>
